export const heater = 'heater';

const branchHandwashing = 'branch-handwashing';
const stepGoalTemp = 'goal-temp';
const stepFlowRate = 'flow-rate';

const stepResult = 'result';
const is3PhasePower = 'is-3-phase-power';
const isPublicHandwashing = 'is-public-handwashing';
const hasMixingValve = 'has-mixing-valve';
const stepVoltage = 'voltage';

export default [
  {
    id: `${branchHandwashing}_${is3PhasePower}`,
    step: '3-phase power',
    component: 'Selector',
    title: 'Is 3-phase power going to be used?',
    tip: '<b>Note</b>: For higher GPM flow rates (+4 GPM), you will likely need 3-Phase power to facilitate the higher kW necessary to achieve higher temperatures!!',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchHandwashing}_3phase_${stepVoltage}`,
        typeYes: true,
        params: { 'product-family': ['27ccfe56-9d53-4acf-9cd8-9c80e38fc8a7'] },
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchHandwashing}_1phase_${isPublicHandwashing}`,
        typeNo: true,
        params: { phase: 1 },
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_${isPublicHandwashing}`,
    step: 'Public Handwashing',
    component: 'Selector',
    title: 'Does this application meet the definition of Public Handwashing?',
    tip: '<b>Note</b>: Public handwashing is normally designated under UPC 419.3 and IPC 419.5 requiring that an ASSE-1070 mixing valve should be installed on ALL lavatories located in a toilet room with 2 exceptions: Residences, Hotel rooms. However, this leaves much to the interpretation of the code to the AHJ (authorities having jurisdiction), so always follow the guidance of your local code officials.',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchHandwashing}_1phase_${hasMixingValve}`,
        typeYes: true,
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchHandwashing}_1phase_tempDetails`,
        typeNo: true,
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_${hasMixingValve}`,
    step: 'Mixing Valve',
    component: 'Selector',
    title: 'Does this application already have an ASSE-1070 mixing valve installed internally or externally to faucet(s)?',
    options: [
      {
        title: 'Yes',
        value: '1',
        nextId: `${branchHandwashing}_1phase_tempDetails`,
        typeYes: true,
      },
      {
        title: 'No',
        value: '0',
        nextId: `${branchHandwashing}_1phase_noMixingValve_${stepVoltage}`,
        params: { application: ['public-handwashing'], 'product-family': ['1f62efe8-c76e-448d-987b-e678c1c161ef'] },
        typeNo: true,
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_tempDetails`,
    step: 'Details',
    component: 'Selector',
    title: 'OK, let’s define your application a bit further...',
    options: [
      {
        title: 'I need a unit for hot water needs between 100°F – 140°F',
        value: '1',
        params: { application: ['standard-hand-sink'], 'product-family': ['e15fa1b4-927d-44d8-a001-dd5d6c132c7f'] },
        nextId: `${branchHandwashing}_1phase_t100-140_${stepVoltage}`,
      },
      {
        title: 'I need a unit for multiple handwashing faucets set @ 110°F',
        value: '0',
        params: { application: ['standard-hand-sink'], 'product-family': ['e15fa1b4-927d-44d8-a001-dd5d6c132c7f'] },
        nextId: `${branchHandwashing}_1phase_t110_${stepVoltage}`,
      },
    ],
  },
  // branch Handwashing - 1 phase - no mixing valve
  {
    id: `${branchHandwashing}_1phase_noMixingValve_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchHandwashing}_1phase_noMixingValve_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchHandwashing}_1phase_noMixingValve_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchHandwashing}_1phase_noMixingValve_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchHandwashing}_1phase_noMixingValve_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  {
    id: `${branchHandwashing}_1phase_noMixingValve_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’), or if the GPM flow rate is higher than 1.5 GPM. Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchHandwashing}_1phase_noMixingValve_${stepGoalTemp}`,
    title: 'Which faucets would the unit be servicing?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Handwashing Sink',
        flowRate: '0.5 GPM',
        flowRateValue: 0.5,
        img: `${process.env.VUE_APP_PATH}/img/LFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderate Flow Handwashing Sink',
        flowRate: '~1 GPM',
        flowRateValue: 1,
        img: `${process.env.VUE_APP_PATH}/img/MFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderately High Flow Handwashing Sink',
        flowRate: '~1.5 GPM',
        flowRateValue: 1.5,
        img: `${process.env.VUE_APP_PATH}/img/MHFHS.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_noMixingValve_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax recommends heaters for Handwashing to be set between 105°F - 110°F, not to exceed.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 110,
    locked: false,
    nextId: `${branchHandwashing}_1phase_noMixingValve_${stepResult}`,
  },
  {
    id: `${branchHandwashing}_1phase_noMixingValve_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Handwashing - 1 phase - temp 100-140
  {
    id: `${branchHandwashing}_1phase_t100-140_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchHandwashing}_1phase_t100-140_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchHandwashing}_1phase_t100-140_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchHandwashing}_1phase_t100-140_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchHandwashing}_1phase_t100-140_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  {
    id: `${branchHandwashing}_1phase_t100-140_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’), or if the GPM flow rate is higher than 1.5 GPM. Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchHandwashing}_1phase_t100-140_${stepGoalTemp}`,
    title: 'Which faucets would the unit be servicing?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Handwashing Sink',
        flowRate: '0.5 GPM',
        flowRateValue: 0.5,
        img: `${process.env.VUE_APP_PATH}/img/LFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderate Flow Handwashing Sink',
        flowRate: '~1 GPM',
        flowRateValue: 1,
        img: `${process.env.VUE_APP_PATH}/img/MFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderately High Flow Handwashing Sink',
        flowRate: '~1.5 GPM',
        flowRateValue: 1.5,
        img: `${process.env.VUE_APP_PATH}/img/MHFHS.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_t100-140_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax recommends heaters for Handwashing to be set between 105°F - 110°F, not to exceed. 120°F is the standard LavAdvantage product temperature set point for use with small breakroom/kitchen sinks.\n',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    tip: '<b>Note</b>: 120V may not allow ample kW needed for higher flow rates & temperature rises to reach goal temperatures in certain climates',
    defaultValue: 120,
    locked: false,
    nextId: `${branchHandwashing}_1phase_t100-140_${stepResult}`,
  },
  {
    id: `${branchHandwashing}_1phase_t100-140_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Handwashing - 1 phase - temp 110
  {
    id: `${branchHandwashing}_1phase_t110_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    options: [
      { title: '120 V', value: 120, nextId: `${branchHandwashing}_1phase_t110_${stepFlowRate}` },
      { title: '208 V', value: 208, nextId: `${branchHandwashing}_1phase_t110_${stepFlowRate}` },
      { title: '240 V', value: 240, nextId: `${branchHandwashing}_1phase_t110_${stepFlowRate}` },
      { title: '277 V', value: 277, nextId: `${branchHandwashing}_1phase_t110_${stepFlowRate}` },
    ],
    paramName: 'volts',
  },
  {
    id: `${branchHandwashing}_1phase_t110_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’), or if the GPM flow rate is higher than 1.5 GPM. Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchHandwashing}_1phase_t110_${stepGoalTemp}`,
    title: 'Which faucets would the unit be servicing?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Handwashing Sink',
        flowRate: '0.5 GPM',
        flowRateValue: 0.5,
        img: `${process.env.VUE_APP_PATH}/img/LFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderate Flow Handwashing Sink',
        flowRate: '~1 GPM',
        flowRateValue: 1,
        img: `${process.env.VUE_APP_PATH}/img/MFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderately High Flow Handwashing Sink',
        flowRate: '~1.5 GPM',
        flowRateValue: 1.5,
        img: `${process.env.VUE_APP_PATH}/img/MHFHS.jpg`,
        quantity: 0,
      },
    ],
  },
  {
    id: `${branchHandwashing}_1phase_t110_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax recommends heaters for Handwashing to be set between 105°F - 110°F, not to exceed.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 110,
    locked: false,
    nextId: `${branchHandwashing}_1phase_t110_${stepResult}`,
  },
  {
    id: `${branchHandwashing}_1phase_t110_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  // branch Handwashing - 3 phase
  {
    id: `${branchHandwashing}_3phase_${stepVoltage}`,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of 3-Phase voltage for your heater?',
    options: [
      { title: '208 V', params: { volts: 208 }, nextId: `${branchHandwashing}_3phase_${stepFlowRate}` },
      { title: '480 V', params: { volts: 480 }, nextId: `${branchHandwashing}_3phase_${stepFlowRate}` },
    ],
  },
  {
    id: `${branchHandwashing}_3phase_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’), or if the GPM flow rate is higher than 1.5 GPM. Continue below to select the local fixtures.',
    paramName: 'max-flow',
    nextId: `${branchHandwashing}_3phase_${stepGoalTemp}`,
    title: 'Which faucets would the unit be servicing?',
    text: 'IMPORTANT!! The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above',
    fixtures: [
      {
        title: 'Low Flow Handwashing Sink',
        flowRate: '0.5 GPM',
        flowRateValue: 0.5,
        img: `${process.env.VUE_APP_PATH}/img/LFHS.jpg`,
        quantity: 2,
      },
      {
        title: 'Moderate Flow Handwashing Sink',
        flowRate: '~1 GPM',
        flowRateValue: 1,
        img: `${process.env.VUE_APP_PATH}/img/MFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Moderately High Flow Handwashing Sink',
        flowRate: '~1.5 GPM',
        flowRateValue: 1.5,
        img: `${process.env.VUE_APP_PATH}/img/MHFHS.jpg`,
        quantity: 0,
      },
      {
        title: 'High Flow Handwashing Sink',
        flowRate: '~2 GPM',
        flowRateValue: 2,
        img: `${process.env.VUE_APP_PATH}/img/HFHS.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: `${branchHandwashing}_3phase_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    paramName: 'temp-out',
    title: 'Goal Temperature (°F)',
    text: 'Eemax recommends heaters for Handwashing to be set between 105°F - 110°F, not to exceed.',
    hint: 'If you have a different goal temperature, enter that above, otherwise you can leave it at the default entry',
    defaultValue: 110,
    locked: false,
    nextId: `${branchHandwashing}_3phase_${stepResult}`,
  },
  {
    id: `${branchHandwashing}_3phase_${stepResult}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
];
